import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { EditableFieldBase } from '../editable-field-base';

@Component({
    selector: 'boolean-slider',
    templateUrl: './boolean-slider.component.html',
    styleUrls: ['./boolean-slider.component.scss', '../editable-fields.scss'],
    standalone: false
})
export class BooleanSlider extends EditableFieldBase {

  @Input() trueLabel: string;                     // the text to show on the "true/on" side of the slider
  @Input() falseLabel: string;                    // the text to show on the "false/off" side of the slider
  @Input() size: string;                          // "sm" or blank

  public readOnlyValue$: Observable<string>;      // This makes the read only value display the label correctly

  constructor() {
    super();
  }

  public ngOnInit(): void {
    super.ngOnInit();

    this.readOnlyValue$ = this.value$.pipe(
      map((val) => val ? this.trueLabel : this.falseLabel),
      shareReplay({ bufferSize: 1, refCount: true }),
    );
  }

  // overrides base class
  public onChange(): void {
    // change the value in the bound object 
    this.obj[this.prop] = !this.obj[this.prop];

    //  This control instance only has one event - that the value is changed.  At that point it's submitted and
    //  that is when we can run validate and change.
    this.validate();
    super.onChange(); 
  }

  //readOnlyValue
}





